import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer
} from "recharts";
import { Box, Typography } from "@mui/material";

function FinancialChart({ entity, selectedMetrics = [], period = "1Y" }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const metric = selectedMetrics?.[0] || "";

  const getStartDateFromPeriod = (period) => {
    const now = new Date();
    const date = new Date(now);
    if (period.endsWith("Q")) {
      date.setMonth(date.getMonth() - parseInt(period[0]) * 3);
    } else if (period.endsWith("Y")) {
      date.setFullYear(date.getFullYear() - parseInt(period[0]));
    }
    return date.toISOString().split("T")[0];
  };

  const startDate = getStartDateFromPeriod(period);
  const endDate = new Date().toISOString().split("T")[0];

  useEffect(() => {
    if (!metric || !entity) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/financials/${entity}`,
          {
            params: {
              metrics: metric,
              startDate,
              endDate
            }
          }
        );

        const rawData = res.data || [];

        // Transform long format to wide format grouped by date
        const grouped = {};
        rawData.forEach(({ FiledDate, Metric, Value }) => {
          if (!grouped[FiledDate]) grouped[FiledDate] = { date: FiledDate };
          grouped[FiledDate][Metric] = Value;
        });

        const transformed = Object.values(grouped);
        console.log("Transformed chart data:", transformed);
        setData(transformed);
      } catch (err) {
        console.error("Error fetching financial chart data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [entity, metric, startDate, endDate]);

  if (!metric) return <Typography>Select a metric to view data.</Typography>;
  if (loading) return <Typography>Loading financial data...</Typography>;
  if (error) return <Typography color="error">Error loading chart: {error.message}</Typography>;
  if (data.length === 0) return <Typography>No data found for this metric.</Typography>;

  return (
    <Box sx={{ width: "100%", height: 400, mt: 2 }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey={metric}
            stroke="#8884d8"
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default FinancialChart;
